import { Link } from '@pluxee-design-system/core';
import { ComponentProps } from 'components/VirtualizedTable/types';
import { Location } from 'generated/models';
import NextLink from 'next/link';
import { useCallback } from 'react';
import gtm from 'trackers/gtm';

const MasterIdCell = ({ index, row: { masterId, uid, name } }: ComponentProps<Location>) => {
  const trackClick = useCallback(() => {
    gtm.trackClickLocationsDetails(uid, name, index);
  }, [index, name, uid]);

  return (
    <Link as={NextLink} href={`/locations/${uid}`} onClick={trackClick} prefetch={false}>
      {masterId || <>&mdash;</>}
    </Link>
  );
};

export default MasterIdCell;
